import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import * as Constants from '../../constants/offline.js';
import { notifyOffline } from '../../actions/offlineActions.js';
import { isOffline } from '../../reducers/offlineReducer.js';

const OfflineBanner = ({ offline }) =>
  offline ? (
    <div className="ncss-container bg-accent mb2-sm offline-section text-color-white u-align-center">
      <span className="fs20-sm u-sm-ib pr4-sm pl4-sm">
        <i className="g72-alert" />
      </span>
      <span className="ncss-brand">{Constants.OFFLINE_TITLE}</span>
      <span className="pl2-sm">{Constants.OFFLINE_DESC}</span>
    </div>
  ) : null;

OfflineBanner.propTypes = {
  offline: PropTypes.bool
};
export default connect(
  state => ({
    offline: isOffline(state)
  }),
  { notifyOffline }
)(OfflineBanner);
